"use client";
/* Core */
import { createSlice } from "@reduxjs/toolkit";
import { getRoundMultiplier } from "./actions";

const initialState = {
  loading: false,
  roundMultiplierList: [],
  totalRoundMultiplier: 0,
  myRoundMultiplier: null
};

export const roundMultiplierSlice = createSlice({
  name: "roundMultiplierSlice",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(getRoundMultiplier.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getRoundMultiplier.fulfilled, (state, action) => {
        state.loading = false;
        state.roundMultiplierList =
          action.payload?.filter?.page === 1
            ? action.payload.data
            : [...state.roundMultiplierList, ...action.payload.data];
        state.totalRoundMultiplier = action.payload.totalcount;
        state.myRoundMultiplier = action.payload.myRoundMultiplier
      })
      .addCase(getRoundMultiplier.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export default roundMultiplierSlice.reducer;
